import React from 'react';
import './PageHeader.css';

const PageHeader = ({ children }) => {
  return (
    <div className="page-header">
      {/* <div className="page-header-line page-header-line-right"></div> */}
      <div className="page-header-content">
        {/* <span className="page-header-quote page-header-quote-top">"</span> */}
        <p className="page-header-text">{children}</p>
        {/* <span className="page-header-quote page-header-quote-bottom">"</span> */}
      </div>
      {/* <div className="page-header-line page-header-line-left"></div> */}
    </div>
  );
};

export default PageHeader;